import React from "react";

import Card from "@src/multiCustodian/components/FinancialPlans/CreateUpdatePlanFlow/pages/Shared/Card/Card";
import Subscript from "@src/sharedComponents/Typography/Subscript";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./FilledCard.module.css";

interface Props {
  title: string;
  titleRight?: React.ReactNode;
  subTitle?: string;
  heading: string;
  headingSubtitle?: string;
  text: string;
  checkboxLabel?: string;
  isChecked?: boolean;
  onCheckboxChange?: (isChecked: boolean) => void;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  isMutating?: boolean;
  checkboxIsDisabled?: boolean;
  checkboxTooltipText?: string;
  titleSubScript?: string;
}

const FilledCard = ({
  checkboxLabel,
  className,
  heading,
  headingSubtitle,
  isChecked,
  onCheckboxChange,
  onClick,
  subTitle,
  titleSubScript,
  text,
  title,
  titleRight,
  isMutating,
  checkboxIsDisabled,
  checkboxTooltipText,
}: Props): JSX.Element => {
  return (
    <Card
      onClick={onClick}
      title={
        <div
          className={titleSubScript !== undefined ? styles.titleContainer : ""}
        >
          <Text variant={"title1"}>{title}</Text>
          {titleSubScript !== undefined && (
            <Subscript
              className={styles.titleRightMargin}
              variant={"bodySmall"}
              color={"textSubtle"}
            >
              {titleSubScript}
            </Subscript>
          )}
        </div>
      }
      subTitle={
        <Text variant={"bodySmall"} color={"textSubtle"}>
          {subTitle}
        </Text>
      }
      titleRight={
        <Text variant={"body"} color={"text"}>
          {titleRight}
        </Text>
      }
      heading={
        <Text className={styles.heading} variant={"title2"}>
          {heading}
        </Text>
      }
      headingSubtitle={
        <Text variant={"bodySmall"} color={"textSubtle"}>
          {headingSubtitle}
        </Text>
      }
      text={
        <Text variant="body" color={"textSubtle"}>
          {text}
        </Text>
      }
      checkboxLabel={checkboxLabel}
      isChecked={isChecked}
      checkboxIsDisabled={checkboxIsDisabled}
      checkboxTooltipText={checkboxTooltipText}
      onCheckboxChange={onCheckboxChange}
      className={className}
      isMutating={isMutating}
    />
  );
};

export default FilledCard;
